module.exports = __webpack_public_path__ + "img/calendar2.929fd11b.png";